// extracted by mini-css-extract-plugin
module.exports = {"team":"style_team__469_D","playerInfo":"style_playerInfo__QJL39","title":"style_title__n6eO5","playerList":"style_playerList__96JX6","benchList":"style_benchList__fkQkA"};